import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { stashResetTokenFromUrl } from '@utils';

import { AppModule } from './app/app.module';

// Before bootstrap, so GA never sees the reset token in `document.location`.
stashResetTokenFromUrl();

platformBrowserDynamic()
  .bootstrapModule(AppModule, {
    ngZoneEventCoalescing: true,
  })
  .catch(err => console.error(err));
